import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.loadingOlderMessages = false
    this.stickToBottom = true
    this.handleScroll = this.handleScroll.bind(this)
    this.handleMutations = this.handleMutations.bind(this)
    this.handleWindowLoad = this.handleWindowLoad.bind(this)
    this.handleResize = this.handleResize.bind(this)

    this.scrollToBottomSoon()
    this.element.addEventListener('scroll', this.handleScroll, { passive: true })
    this.observer = new MutationObserver(this.handleMutations)
    this.observer.observe(this.element, { childList: true, subtree: true })
    window.addEventListener('load', this.handleWindowLoad)

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.handleResize)
      this.resizeObserver.observe(this.element)
    }
  }

  disconnect () {
    if (this.observer) this.observer.disconnect()
    if (this.resizeObserver) this.resizeObserver.disconnect()
    window.removeEventListener('load', this.handleWindowLoad)
    this.element.removeEventListener('scroll', this.handleScroll)
  }

  prepareOlderLoad () {
    this.loadingOlderMessages = true
  }

  handleMutations () {
    if (this.loadingOlderMessages) {
      this.loadingOlderMessages = false
      return
    }

    if (this.stickToBottom) this.scrollToBottomSoon()
  }

  handleScroll () {
    this.stickToBottom = this.nearBottom
  }

  handleWindowLoad () {
    this.scrollToBottomSoon()
  }

  handleResize () {
    if (this.stickToBottom) this.scrollToBottomSoon()
  }

  scrollToBottom () {
    this.element.scrollTop = this.element.scrollHeight
    this.stickToBottom = true
  }

  scrollToBottomSoon () {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.scrollToBottom()
      })
    })
  }

  get nearBottom () {
    const remaining = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
    return remaining < 80
  }
}
